"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24' }, restProps),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18.594 6.21967C18.8625 6.48816 18.8849 6.90955 18.6612 7.20353L18.594 7.28033L13.7504 12.124C13.5941 12.2802 13.5941 12.5335 13.7504 12.6897L18.594 17.5334C18.8869 17.8263 18.8869 18.3011 18.594 18.594C18.3256 18.8625 17.9042 18.8849 17.6102 18.6612L17.5334 18.594L12.6897 13.7504C12.5335 13.5941 12.2802 13.5941 12.124 13.7504L7.28033 18.594C6.98744 18.8869 6.51256 18.8869 6.21967 18.594C5.95118 18.3256 5.92881 17.9042 6.15255 17.6102L6.21967 17.5334L11.0634 12.6897C11.2196 12.5335 11.2196 12.2802 11.0634 12.124L6.21967 7.28033C5.92678 6.98744 5.92678 6.51256 6.21967 6.21967C6.48816 5.95118 6.90955 5.92881 7.20353 6.15255L7.28033 6.21967L12.124 11.0634C12.2802 11.2196 12.5335 11.2196 12.6897 11.0634L17.5334 6.21967C17.8263 5.92678 18.3011 5.92678 18.594 6.21967Z' })));
}
exports.default = SvgComponent;
